import Vue from 'vue'
import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { Toast, Dialog } from 'vant'
import Cookies from 'js-cookie'
import mobile from 'is-mobile'
import getTranslation from '@/locale/getTranslation'
import sha256 from 'crypto-js/sha256'

const service = axios.create({
  timeout: 20000
})
// loading 组
// loading 组
let ARR_LOADING = []
// let IS_LOADING = false
let LOADING_INSTANCE = []

service.interceptors.request.use(config => {
  // do something before request is sent
  if (config.isLoading) {
    if (config.once) {
      if (ARR_LOADING.find(val => config.url === val.url)) {
        return false
      }
    }
    let loadingConfig = {
      text: '努力加载中',
      target: config.target || '.mainCon'
    }
    if (!ARR_LOADING.find(val => val.target === loadingConfig.target)) {
      LOADING_INSTANCE.push({
        loading: Vue.$loading(loadingConfig),
        target: loadingConfig.target
      })
    }
    ARR_LOADING.push({ url: config.url, target: loadingConfig.target })
  }
  if (config.isCsrf && Cookies.get('csrfToken')) {
    Object.assign(config.headers, {
      'x-csrf-token': Cookies.get('csrfToken')
    })
  }
  Object.assign(config.headers, {
    'tenant-name': 'ciftis'
  })
  let at = Cookies.get('ciftis_at')
  if (at) {
    config.headers['Authorization'] = `Bearer ${at}`
  }
  Object.assign(config.headers, {
    'Content-Type': 'application/json'
  })
  if (config.url.startsWith('/v1')) {
    const timestamp = new Date().valueOf()
    const clientId = '630c5263e4b0caa7e8ef71ad'
    const clientSecret = 'QMpTNsgGrh6sUXGwY5a2mQJVV2nCjceJlGYwG2OxHuy'
    const signature = sha256(
      `${clientId}&${clientSecret}&${timestamp}`
    ).toString()
    Object.assign(config.headers, {
      'X-OS-Timestamp': timestamp,
      'X-OS-Client-Id': clientId,
      'X-OS-Signature': signature
    })
  }
  return config
})
service.interceptors.response.use(
  response => {
    let { data, config } = response
    if (config.isLoading) {
      let index = ARR_LOADING.findIndex(val => val.url === config.url)
      ARR_LOADING.splice(index, 1)
      let target = config.target || '.mainCon'
      if (!ARR_LOADING.find(val => val.target === target)) {
        let VUE_LOADINGIndex = LOADING_INSTANCE.findIndex(
          val => val.target === target
        )
        if (VUE_LOADINGIndex !== -1) {
          LOADING_INSTANCE[VUE_LOADINGIndex].loading.close()
          LOADING_INSTANCE.splice(VUE_LOADINGIndex, 1)
        }
      }
    }
    return data
  },
  error => {
    let { config, response } = error
    if (config.isLoading) {
      let index = ARR_LOADING.findIndex(val => val.url === config.url)
      ARR_LOADING.splice(index, 1)
      let target = config.target || '.mainCon'
      if (!ARR_LOADING.find(val => val.target === target)) {
        let VUE_LOADINGIndex = LOADING_INSTANCE.findIndex(
          val => val.target === target
        )
        if (VUE_LOADINGIndex !== -1) {
          LOADING_INSTANCE[VUE_LOADINGIndex].loading.close()
          LOADING_INSTANCE.splice(VUE_LOADINGIndex, 1)
        }
      }
    }
    const { status, data } = response
    if (status === 401 && config.isLogin) {
      try {
        window.bridge.startLoginPage(
          JSON.stringify({
            source: 'mediaCenter', // 注册：register， 忘记密码：forgetPsw， 预约系统： orderSystem
            type: 'media' // 个人用户登录：personal, 企业用户登录：company
          })
        )
      } catch (err) {
        console.log('APP跳转登录失败')
        window.location.href = process.env.VUE_APP_MEDIACENTER + '/web/login'
      }
      // window.location.href = process.env.VUE_APP_MEDIA + '/web/login'
      // const href = location.href
      // if (href.includes('company')) {
      //   location.href = `${
      //     process.env.VUE_APP_LOGIN_URL_COMPANY
      //   }?returnUrl=${encodeURIComponent(href)}`
      // } else {
      //   location.href = `${
      //     process.env.VUE_APP_LOGIN_URL_PERSONAL
      //   }?returnUrl=${encodeURIComponent(href)}`
      // }
      return
    }
    if (status === 429) {
      if (mobile()) {
        Dialog.alert({
          message: getTranslation(
            '目前操作人数过多，系统繁忙，请稍后刷新再试一次。'
          )
        })
      } else {
        MessageBox.alert(
          getTranslation('目前操作人数过多，系统繁忙，请稍后刷新再试一次。'),
          '',
          {
            confirmButtonText: getTranslation('确定')
          }
        )
      }
      return Promise.reject(error)
    }
    if (config.isOutMsg) {
      const msg =
        (data && data.error && data.error.message) ||
        '出错啦，请确认网络是否正常，稍后再试'
      if (mobile()) {
        Toast(getTranslation(msg))
      } else {
        Message({
          type: 'error',
          message: getTranslation(msg)
        })
      }
    }
    return Promise.reject({ status, data })
  }
)
export default service
